(function () {
  'use strict';

  function normalizePath(value) {
    if (!value) return '';
    var path = '';
    try {
      var url = new URL(value, window.location.origin);
      path = url.pathname;
    } catch (error) {
      path = String(value).split('#')[0].split('?')[0];
    }
    path = (path.replace(/\/$/, '') || '/').toLowerCase();

    if (path === '/collections/interface-connectors-featured' || path === '/collections/interface-connectors1') {
      return '/collections/interface-connectors';
    }

    if (path === '/collections/lcd-screens') {
      return '/collections/displays';
    }

    return path;
  }

  function markCurrentPageSubcategory() {
    var nav = document.querySelector('.treedix-category-page .treedix-category-tabs');
    if (!nav) return;

    var currentKey = normalizePath(window.location.href);
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href]'));
    var activeLink = null;

    links.forEach(function (link) {
      var key = normalizePath(link.getAttribute('href'));
      var serverActive = link.getAttribute('data-category-current') === 'true';
      link.classList.remove('is-active');
      if (link.getAttribute('aria-current') === 'page') link.removeAttribute('aria-current');
      if ((key && key === currentKey) || serverActive) activeLink = link;
    });

    if (activeLink) {
      activeLink.classList.add('is-active');
      activeLink.setAttribute('aria-current', 'page');
    }
  }

  function getPageSubcategoryItems() {
    var nav = document.querySelector('.treedix-category-page .treedix-category-tabs');
    if (!nav) return [];
    return Array.prototype.slice.call(nav.querySelectorAll('a[href]')).map(function (link) {
      return {
        label: link.textContent.trim(),
        href: link.getAttribute('href'),
        key: normalizePath(link.getAttribute('href')),
        active: link.classList.contains('is-active') || link.getAttribute('aria-current') === 'page'
      };
    }).filter(function (item) { return item.label && item.key; });
  }

  function getHeaderLinks() {
    var header = document.querySelector('.tl-final-header');
    if (!header) return [];
    return Array.prototype.slice.call(header.querySelectorAll('.tl-final-nav__dropdown a[href], .tl-final-mobile-menu a[href], .tl-final-mobile-submenu a[href]'));
  }

  function centerActivePillHorizontally() {
    var activePill = document.querySelector('.treedix-category-page .treedix-category-tabs a.is-active, .treedix-category-page .treedix-category-tabs a[aria-current="page"]');
    if (!activePill) return;

    var container = activePill.closest('.treedix-category-tabs');
    if (!container || !container.scrollTo) return;

    var left = activePill.offsetLeft - (container.clientWidth - activePill.clientWidth) / 2;
    container.scrollTo({
      left: Math.max(0, left),
      behavior: 'auto'
    });
  }

  function applyCollectionProductContext() {
    var page = document.querySelector('.treedix-category-page[data-current-collection]');
    if (!page) return;

    var collectionHandle = page.getAttribute('data-current-collection');
    if (!collectionHandle) return;

    var selector = [
      '.treedix-category-card__image[href]',
      '.treedix-category-card__body > a[href]',
      '.treedix-category-mini[href]'
    ].join(',');

    Array.prototype.slice.call(page.querySelectorAll(selector)).forEach(function (link) {
      var rawHref = link.getAttribute('href');
      if (!rawHref) return;

      try {
        var url = new URL(rawHref, window.location.origin);
        if (url.pathname.indexOf('/products/') !== 0) return;
        link.setAttribute('href', '/collections/' + collectionHandle + url.pathname + url.search + url.hash);
      } catch (error) {
        if (rawHref.indexOf('/products/') === 0) {
          link.setAttribute('href', '/collections/' + collectionHandle + rawHref);
        }
      }
    });
  }

  function syncCategorySubcategories() {
    markCurrentPageSubcategory();
    applyCollectionProductContext();

    var items = getPageSubcategoryItems();
    if (!items.length) return;
    var itemByKey = items.reduce(function (map, item) { map[item.key] = item; return map; }, {});
    var hasActiveHeaderChild = false;

    getHeaderLinks().forEach(function (link) {
      var item = itemByKey[normalizePath(link.getAttribute('href'))];
      if (!item) return;
      link.textContent = item.label;
      if (item.active) {
        hasActiveHeaderChild = true;
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      } else {
        link.classList.remove('is-active');
        if (link.getAttribute('aria-current') === 'page') link.removeAttribute('aria-current');
      }
    });

    centerActivePillHorizontally();

    document.querySelectorAll('.tl-final-nav__item--product').forEach(function (item) {
      if (hasActiveHeaderChild && item.querySelector('.tl-final-nav__dropdown a.is-active, .tl-final-nav__dropdown a[aria-current="page"]')) {
        item.classList.add('is-active');
        item.classList.add('is-current-parent');
      } else {
        item.classList.remove('is-active');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCategorySubcategories);
  else syncCategorySubcategories();
  document.addEventListener('shopify:section:load', syncCategorySubcategories);
  document.addEventListener('shopify:block:select', syncCategorySubcategories);
  document.addEventListener('shopify:block:deselect', syncCategorySubcategories);

  if (document.body) {
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        var target = mutation.target;
        if (!target) return false;
        if (target.nodeType === Node.TEXT_NODE) target = target.parentElement;
        return target && target.closest && target.closest('.treedix-category-page');
      });
      if (shouldSync) window.requestAnimationFrame(syncCategorySubcategories);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
